import { ComponentAccessUserService } from "src/app/core/services/utelize/system/component-access/component-access-user-service";
import { DashboardComponent } from "./dashboards/dashboard/dashboard.component";
import { inject, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsageDashboardComponent } from "./dashboards/usage-dashboard/usage-dashboard.component";

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: () => {
          return inject(ComponentAccessUserService).dashboardUrl;
        }
    },
    // {
    //   path: '', loadChildren: () => import('./dashboards/dashboards.module').then(m => m.DashboardsModule)
    // },
    {
      path: 'advance-ui', loadChildren: () => import('./advance-ui/advance-ui.module').then(m => m.AdvanceUiModule)
    },
    {
      path: 'apps', loadChildren: () => import('./apps/apps.module').then(m => m.AppsModule)
    },
    {
      path: 'charts', loadChildren: () => import('./charts/charts.module').then(m => m.ChartsModule)
    },
    {
      path: 'dashboard-main', component: DashboardComponent
    },
    {
      path: 'dashboard-usage', component: UsageDashboardComponent
    },
    {
      path: 'device-management', loadChildren: () => import('./device-management/device-management.module').then(m => m.DeviceManagementModule)
    },
    {
      path: 'communication', loadChildren: () => import('./communication/communication.module').then(m => m.CommunicationModule)
    },
    {
      path: 'companies', loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesModule)
    },
    {
      path: 'configuration', loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationModule)
    },
    {
      path: 'crm', loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
    },
    {
      path: 'crypto', loadChildren: () => import('./crypto/crypto.module').then(m => m.CryptoModule)
    },
    {
      path: 'demos', loadChildren: () => import('./demos/demos.module').then(m => m.DemosModule)
    },
    {
      path: 'invoices', loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesModule)
    },
    {
      path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then(m => m.EcommerceModule)
    },
    {
      path: 'forms', loadChildren: () => import('./form/form.module').then(m => m.FormModule)
    },
    {
      path: 'icons', loadChildren: () => import('./icons/icons.module').then(m => m.IconsModule)
    },
    {
      path: 'links', loadChildren: () => import('./links/links.module').then(m => m.LinksModule)
    },
    {
      path: 'location-services', loadChildren: () => import('./location-services/location-services.module').then(m => m.LocationServicesModule)
    },
    {
      path: 'marletplace', loadChildren: () => import('./nft-marketplace/nft-marketplace.module').then(m => m.NftMarketplaceModule)
    },
    {
      path: 'maps', loadChildren: () => import('./maps/maps.module').then(m => m.MapsModule)
    },
    {
      path: 'pages', loadChildren: () => import('./extrapages/extraspages.module').then(m => m.ExtraspagesModule)
    },
    {
      path: 'projects', loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule)
    },
    {
      path: 'provisioning', loadChildren: () => import('./provisioning/provisioning.module').then(m => m.ProvisioningModule)
    },
    {
      path: 'reporting', loadChildren: () => import('./reporting/reporting.module').then(m => m.ReportingModule)
    },
    {
      path: 'risk-intelligence', loadChildren: () => import('./risk-intelligence/risk-intelligence.module').then(m => m.RiskIntelligenceModule)
    },
    {
      path: 'signals', loadChildren: () => import('./signals/signals.module').then(m => m.SignalsModule)
    },
    {
      path: 'suppliers', loadChildren: () => import('./suppliers/suppliers.module').then(m => m.SuppliersModule)
    },
    {
      path: 'support', loadChildren: () => import('./support/support.module').then(m => m.SupportModule)
    },
    {
      path: 'system-admin', loadChildren: () => import('./system-admin/system-admin.module').then(m => m.SystemAdminModule)
    },
    {
      path: 'tables', loadChildren: () => import('./tables/tables.module').then(m => m.TablesModule)
    },
    {
      path: 'tariffs', loadChildren: () => import('./tariffs/tariffs.module').then(m => m.TariffsModule)
    },
    {
      path: 'tasks', loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule)
    },
    {
      path: 'tickets', loadChildren: () => import('./tickets/tickets.module').then(m => m.TicketsModule)
    },
    {
      path: 'timeline', loadChildren: () => import('./timeline/timeline.module').then(m => m.TimelineModule)
    },
    { 
      path: 'ui', loadChildren: () => import('./ui/ui.module').then(m => m.UiModule) 
    },
    {
      path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
    },
    {
      path: 'web-components', loadChildren: () => import('./web-components/web-components.module').then(m => m.WebComponentsModule)
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
